import { render, staticRenderFns } from "./ConductoresPantalla.vue?vue&type=template&id=753e20ef&"
import script from "./ConductoresPantalla.vue?vue&type=script&lang=ts&"
export * from "./ConductoresPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('753e20ef', component.options)
    } else {
      api.reload('753e20ef', component.options)
    }
    module.hot.accept("./ConductoresPantalla.vue?vue&type=template&id=753e20ef&", function () {
      api.rerender('753e20ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Conductores/ConductoresPantalla.vue"
export default component.exports